import React, { FC, MouseEvent, useMemo } from "react";
import { NotificationBanner as Notification } from "Contexts/notification-banners-context";
import InlineSvg from "Shared/components/inline-svg";
import { useTranslation } from "Shared/util/custom-hooks";
import styles from "./notification-banners.css";
import { getTypeClass } from "./utils";

type NotificationBannerProps = {
    notification: Notification;
    onNotificationClose: (event?: MouseEvent<HTMLElement>) => void;
};

export const NotificationBanner: FC<NotificationBannerProps> = ({
    notification: { allowClose, content: notificationContent, id, type },
    onNotificationClose,
}) => {
    const tnt = useTranslation((x) => x.notification_banners);

    const content = useMemo(
        () =>
            typeof notificationContent === "function"
                ? notificationContent(tnt)
                : notificationContent,
        [notificationContent, tnt],
    );

    return (
        <div
            className={`${styles.notificationContainer} ${getTypeClass(type)}`}
        >
            <div className={styles.contentContainer}>{content}</div>
            {allowClose && (
                <InlineSvg
                    className={styles.manualCloseContainer}
                    dataAttributes={{ "data-notificationid": id }}
                    onClick={onNotificationClose}
                    src="/close.svg"
                />
            )}
        </div>
    );
};
